module.exports = __webpack_public_path__ + "img/logo-aniv.26600394.png";